<template>
  <MainLayout>
    <Head>
      <title>{{ title }}</title>
    </Head>
    <template v-slot:header>
      {{ title }}
    </template>

    <div class="mb-4">
      <ButtonGroup>
        <Link :href="$route('spreadsheets.index')">Spreadsheets</Link>
        <Link :href="$route('builds.index')">Builds</Link>
      </ButtonGroup>
    </div>

    <UploadForm :lastBatch="lastBatch" :errors="errors" v-if="page === 1" />

    <DataTable :pagination="importsList" class="mt-4">
        <template v-slot:header>
          <th scope="col">Uploaded by</th>
          <th scope="col">File</th>
          <th scope="col">Created</th>
          <th scope="col">Type</th>
          <th scope="col">Status</th>
          <th scope="col">Results</th>
        </template>

        <template v-for="item in importsList.data" :key="item.id">
          <tr>
            <td>
              <template v-if="item.user">{{ item.user.name }}</template>
              <Badge v-else>N/A</Badge>
            </td>
            <td>
              <a :href="item.import_csv_url"
                 v-if="item.original_filename"
                 class="text-indigo-600 hover:text-indigo-900">
                {{ item.original_filename }}
              </a>
              <Badge v-else>N/A</Badge>
            </td>
            <td><FormattedDate :date="item.created_at" /></td>
            <td>{{ item.type }}</td>
            <td><ImportStatus :status="item.phase" :phase-label="item.phase_label" /></td>
            <td>
              <a :href="item.results_url"
                 class="text-indigo-600 hover:text-indigo-900"
                 v-if="item.results_csv_path">Download</a>
            </td>
          </tr>
          <tr v-if="item.note">
            <td colspan="6" class="-left -wrap px-6 py-2 text-left text-sm text-gray-600 bg-gray-50">
              <strong>Note:</strong> {{ item.note }}
            </td>
          </tr>
        </template>
    </DataTable>
  </MainLayout>
</template>

<script>
import PageComponent from '@/pages/page-component'
import { Link } from '@inertiajs/inertia-vue3'
import DataTable from '@/components/data-table.vue'
import UploadForm from './partials/upload-form'
import FormattedDate from '@/components/formatted-date'
import Badge from '@/components/badge'
import ImportStatus from './partials/import-status'

export default {
  mixins: [
    PageComponent,
  ],

  components: {
    Link,
    UploadForm,
    FormattedDate,
    DataTable,
    Badge,
    ImportStatus,
  },

  props: {
    lastBatch: Object,
    errors: Object,
    importsList: Object,
    page: Number,
  },

  data() {
    return {
      title: 'Upload Spreadsheet',
    }
  },
}
</script>
